<div class="create-holiday-modal" data-automation="create-holiday-modal">
  <ziro-text [fieldId]="'name'" [inlineLabel]="false"></ziro-text>

  <div class="mt-3">
    <ziro-date-ranges
      [fieldId]="'dateTimeRanges'"
      [ranges]="dateTimeRanges()"
      [isFormSubmitted]="isFormSubmitted"
      [canAddRanges]="true"
      [dataAutomation]="'holiday-date-ranges'"
      [inlineLabel]="false"
      [timeIntervalMinutes]="15"
    ></ziro-date-ranges>
  </div>
  <ng-template #errorTemplate>
    @if (
      isFormSubmitted &&
      (validationState === validationStates.INVALID || childFormValidationState === validationStates.INVALID)
    ) {
      <span>
        {{ 'tkey;validators.global.required.missing.error' | translate }}
      </span>
    }
  </ng-template>
</div>
